// Non-persistent topic fixtures share the production UI and request shapes.
const initialTopics = [
  { id: '00000000-0000-4000-8000-000000000001', name: '当日の集合について', kind: 'named', revision: 1, hidden: false, unreadCount: 1, lastMessage: { id: 'demo-topic-message-1', content: '17:00に楽屋口へお集まりください。', messageFormat: 'text', createdAt: '2026-06-30T08:20:00Z' } },
  { id: '00000000-0000-4000-8000-000000000002', name: 'プログラムの確認', kind: 'named', revision: 1, hidden: false, unreadCount: 1, lastMessage: { id: 'demo-topic-message-2', content: '曲目の表記をご確認ください。', messageFormat: 'text', createdAt: '2026-06-30T07:05:00Z' } },
];
const conversations = new Map<string, { topics: any[]; sent: any[] }>();
function demoState(url: URL, scenarioId: string, body: any = {}) {
  const eventId = url.pathname.match(/\/event-chat\/events\/([^/]+)/)?.[1];
  const groupId = url.pathname.match(/\/group-chat\/threads\/([^/]+)/)?.[1];
  const scope = body.scope || url.searchParams.get('scope') || (eventId ? 'event' : groupId ? 'group' : 'individual');
  const conversationId = scope === 'individual' ? 'personal' : body.conversationId || url.searchParams.get('conversationId') || eventId || groupId;
  const key = `${scenarioId}:${scope}:${conversationId}`;
  if (!conversations.has(key)) conversations.set(key, { topics: ['empty', 'new-user'].includes(scenarioId) ? [] : JSON.parse(JSON.stringify(initialTopics)), sent: [] });
  return conversations.get(key)!;
}
export function resetDemoTopics() { conversations.clear(); }
const response = (data: any, status = 200) => new Response(JSON.stringify(data), { status, headers: { 'Content-Type': 'application/json', 'X-Casticart-Demo': 'artist' } });
export function decorateDemoTopicMessages(rows: any[], url: URL, scenarioId: string) {
  const { topics, sent } = demoState(url, scenarioId);
  const ascending = url.pathname.includes('/event-chat/');
  const decorated = [...rows.map((row, index) => {
    const topic = topics.find((item) => item.id === initialTopics[index]?.id);
    return topic ? { ...row, topic_id: topic.id, topic_name: topic.name, topic } : row;
  }), ...sent].sort((a, b) => (ascending ? 1 : -1) * String(a.created_at).localeCompare(String(b.created_at)));
  const selected = url.searchParams.get('topicId');
  return selected ? decorated.filter((row) => row.topic_id === selected) : decorated;
}
export function resolveDemoTopicRequest(url: URL, method: string, input: any, init: any, scenarioId: string) {
  const path = url.pathname;
  const { topics } = demoState(url, scenarioId);
  if (method === 'GET' && path === '/api/chat/topics') return response({ success: true, topics: [...topics].sort((a, b) => String(b.lastMessage?.createdAt).localeCompare(String(a.lastMessage?.createdAt))).filter((row) => url.searchParams.get('includeHidden') === 'true' || !row.hidden), nextCursor: null });
  if (method === 'GET' && path === '/api/chat/topics/events') return response({ success: true, events: [{ id: 'demo-event-summer-concert', name: 'Casticart デモコンサート' }] });
  const isTopicMutation = path.startsWith('/api/chat/topics/');
  const isMessageSend = /\/messages\/text$/.test(path);
  if (method === 'GET' || (!isTopicMutation && !isMessageSend)) return null;
  const mutate = (body: any = {}) => {
    const { topics, sent } = demoState(url, scenarioId, body);
    if (path.endsWith('/read')) {
      topics.forEach((topic) => { if (body.readScope === 'all' || topic.id === body.topicId) topic.unreadCount = 0; });
      return response({ success: true, lastReadMessageId: body.lastReadMessageId, unreadCount: topics.reduce((count, topic) => count + topic.unreadCount, 0), topicUnreadCount: body.topicId ? 0 : null });
    }
    if (isMessageSend) {
      let topic = topics.find((row) => (body.topicId && row.id === body.topicId) || (body.newTopic?.clientId && row.clientId === body.newTopic.clientId));
      if (!topic && body.newTopic) {
        topic = { ...body.newTopic, id: crypto.randomUUID(), name: body.newTopic.kind === 'event' ? 'Casticart デモコンサート' : body.newTopic.name, revision: 1, hidden: false, unreadCount: 0 };
        topics.push(topic);
      }
      const message = { id: crypto.randomUUID(), message_format: 'text', message_type: 'artist_message', content: body.content, created_at: new Date().toISOString(), is_read: false, topic_id: topic?.id, topic_name: topic?.name, topic };
      sent.push(message);
      if (topic) { topic.hidden = false; topic.lastMessage = { id: message.id, content: message.content, messageFormat: 'text', createdAt: message.created_at }; }
      return response({ success: true, topic, message });
    }
    const id = path.split('/')[4];
    const topic = topics.find((row) => row.id === id);
    if (!topic) return response({ error: 'スレッドが見つかりません。' }, 404);
    if (path.endsWith('/visibility')) topic.hidden = Boolean(body.hidden);
    else if (body.revision !== topic.revision) return response({ error: 'スレッドが変更されました。再読み込みしてください。' }, 409);
    else if (body.name?.trim()) { topic.name = body.name.trim(); topic.revision += 1; }
    return response({ success: true, topic });
  };
  if (init?.body != null) {
    try { return mutate(typeof init.body === 'string' ? JSON.parse(init.body) : init.body); }
    catch { return response({ error: '入力内容を確認してください。' }, 422); }
  }
  if (typeof input?.clone === 'function') return input.clone().json().then(mutate);
  return mutate();
}
